NodeList.prototype.addEventListener = function(event, callback, options = null) {
    if (!this.length || typeof callback != 'function') return this;

    this.forEach(el => {
        el.addEventListener(event, callback, options);
    });

    return this;
}